import React, { useState } from "react";
import * as Yup from "yup";
import Entity from "components/Entity";
import { WorkflowListData } from "../WorkflowConfigurations";
import { endpoints } from "config";
import ProgressBar from "components/helpers/ProgressBar/ProgressBar";
import { useDispatch, useSelector } from "react-redux";
import {
  resetRelatedFormReduxData,
  selectOriginFormData,
  selectRelatedFormsIdsToDelete,
} from "reducers/listPage";
import {
  deleteUncompletedItems,
  redirectOnDone,
} from "components/Entity/Entity";
import Button from "components/ui/Button";
import {
  workflowReadOnlyRightsRenderer,
  workflowRightsRenderer,
  workflowValidationSchema,
} from "../WorkflowConfiguration";
import { WorkflowFields } from "../models";
import { selectCreatedDataParentFieldData } from "reducers/nestedCrudMenu";

type WorkflowCreateEditSummaryProps = {
  actionType: "create" | "edit" | "view";
  selectedData: WorkflowListData[];
  onDone(): void;
  idFromRowOption: React.ReactText | null;
  submitButtonText?: string;
  hideActionButton?: boolean;
  currentPage: number;
  totalPages: number;
  cancelOnDone: () => void;
  redirectToDetailsPage: () => void;
  redirectToBuilderPage: () => void;
  workflowId?: number | null;
};

// Validation schema?
// Rights renderer?
// Read only rights renderer?

const fetchConfig = (
  selectedRows: WorkflowListData[],
  idFromRowOption?: React.ReactText | null
) => {
  return {
    params: {
      Id: idFromRowOption ?? selectedRows[0].workflows__ID,
    },
  };
};

type ExtraReadOnlyColumnComponentProps = { onClick: () => void };

const ExtraReadOnlyColumnComponent: React.FC<ExtraReadOnlyColumnComponentProps> = ({
  onClick,
}) => {
  return (
    <div className="ExtraColumnComponent Btn" onClick={onClick}>
      <div className="Text">Update</div>
    </div>
  );
};

const WorkflowCreateEditSummary: React.FC<WorkflowCreateEditSummaryProps> = ({
  actionType,
  selectedData,
  onDone,
  idFromRowOption,
  submitButtonText,
  hideActionButton,
  currentPage,
  totalPages,
  cancelOnDone,
  workflowId,
  redirectToDetailsPage,
  redirectToBuilderPage,
}) => {
  const [loading, setLoading] = useState<boolean>(true);

  // This is essentially a view page
  const initialDataUrl = endpoints.workflowConfiguration.view;

  // console.log("WorkflowCreateEditSummary initialDataUrl: ", initialDataUrl);
  // console.log("WorkflowCreateEditSummary workflowId: ", workflowId);

  const dispatch = useDispatch();

  const originFormData = useSelector(selectOriginFormData);

  const idsToDeleteFromRelatedForm = useSelector(selectRelatedFormsIdsToDelete);

  const createdDataParentFieldData = useSelector(
    selectCreatedDataParentFieldData
  );

  // Delete unused created items in nested form, call delete endpoint
  const removeIncompleteItems = (onDone?: () => void) => {
    if (createdDataParentFieldData) {
      deleteUncompletedItems(onDone);
    } else if (onDone) {
      onDone();
    }
  };

  const noDataOnClose = () => {
    // Cancel button right panel:

    removeIncompleteItems(cancelOnDone ?? onDone);

    // if (
    //   originFormData &&
    //   originFormData.data &&
    //   originFormData.pathName &&
    //   originFormData.pathName !== window.location.pathname
    // ) {
    //   redirectOnDone(
    //     originFormData.actionType,
    //     originFormData.pathName,
    //     originFormData.id
    //   );
    // } else if (
    //   originFormData &&
    //   originFormData.data &&
    //   originFormData.pathName &&
    //   originFormData.pathName === window.location.pathname
    // ) {
    //   deleteUncompletedItems(
    //     idsToDeleteFromRelatedForm,
    //     dispatch,
    //     window.location.pathname,
    //     cancelOnDone ?? onDone
    //   );
    // } else {
    //   resetRelatedFormReduxData(dispatch, cancelOnDone ?? onDone);
    // }
  };

  return (
    <div className="WorkflowCreateEditSummary">
      <div className="WorkflowHeader">
        <div className="Title">Workflow summary</div>

        <div className="Info"></div>

        <div className="Section">
          <div className="Text">Section 3 of 3</div>
        </div>
      </div>
      {/* {!loading && workflowId && ( */}
      {workflowId && (
        <Entity
          initialDataUrl={initialDataUrl}
          readOnly={true}
          submitUrl={initialDataUrl}
          onDone={onDone}
          selectedData={selectedData}
          idFromRowOption={workflowId ?? idFromRowOption}
          formType="json"
          fieldRenderers={workflowRightsRenderer}
          validationSchema={workflowValidationSchema}
          readOnlyFieldRenderers={workflowReadOnlyRightsRenderer}
          nullStringValues={[]}
          fetchConfig={fetchConfig}
          submitButtonText={submitButtonText}
          hideActionButton={hideActionButton}
          wrapperClassName="Workflows WorkflowsSummary"
          groupColumns={
            actionType !== "view"
              ? {
                  workflowbuilder: 2,
                  // details: 2,
                }
              : undefined
          }
          progressBar={
            <ProgressBar currentPage={currentPage} totalPages={totalPages} />
          }
          cancelOnDone={cancelOnDone}
          saveSubmitResponse={true}
          extraReadOnlyColumnComponents={{
            1: <ExtraReadOnlyColumnComponent onClick={redirectToDetailsPage} />,
            2: <ExtraReadOnlyColumnComponent onClick={redirectToBuilderPage} />,
          }}
          alternateSubmitFunction={onDone}
        />
      )}

      {/* {loading && <Spinner />} */}

      {/* {!loading && !workflowId && ( */}
      {!workflowId && (
        <div className="NoData">
          <div className="Text">No data</div>

          <ProgressBar currentPage={currentPage} totalPages={totalPages} />

          <div className="Buttons NoDataButtons">
            <div className="Btn BtnCancel" onClick={noDataOnClose}>
              Cancel
            </div>

            <Button type="button" onClick={noDataOnClose}>
              Save and add
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default WorkflowCreateEditSummary;
